import React from 'react';
import { Table as TableRoot } from 'react-bootstrap';

import { useReports } from '../..';

import TableHead from './TableHead';
import TableBody from './TableBody';

const Table = () => {
  const { isLoading, data } = useReports();

  return (
    <TableRoot hover>
      <TableHead />
      <TableBody
        isLoading={isLoading}
        data={data}
      />
    </TableRoot>
  );
};

export default Table;
